import type {
  CompletePriorityActionInput,
  DashboardApi,
  DismissPriorityActionInput,
  HeaderStatsResponse,
  NetworkHealthResponse,
  PriorityActionsResponse,
  RoutesResponse,
} from "@/features/dashboard/contracts";
import { httpClient } from "@/shared/api/httpClient";

export const realDashboardApi: DashboardApi = {
  async getHeaderStats(): Promise<HeaderStatsResponse> {
    return httpClient.get<HeaderStatsResponse>("/api/home/header-stats");
  },

  async getNetworkHealth(): Promise<NetworkHealthResponse> {
    return httpClient.get<NetworkHealthResponse>("/api/home/network-health");
  },

  async getPriorityActions(input?: { expanded?: boolean }): Promise<PriorityActionsResponse> {
    const qs = input?.expanded ? "?expanded=true" : "";
    return httpClient.get<PriorityActionsResponse>(`/api/home/priority-actions${qs}`);
  },

  async getRoutes(): Promise<RoutesResponse> {
    return httpClient.get<RoutesResponse>("/api/home/routes");
  },

  async dismissPriorityAction(actionKey: string, input?: DismissPriorityActionInput): Promise<unknown> {
    // Backend upserts on (userId, actionKey); snoozedUntil OR permanent
    // controls how it hides the action. Body is non-empty (always at least
    // a {} object) so express body-parser stays happy.
    return httpClient.post(
      `/api/home/priority-actions/${encodeURIComponent(actionKey)}/dismiss`,
      {
        snoozedUntil: input?.snoozedUntil ?? null,
        permanent: input?.permanent ?? null,
      },
    );
  },

  async completePriorityAction(actionKey: string, input?: CompletePriorityActionInput): Promise<unknown> {
    return httpClient.post(
      `/api/home/priority-actions/${encodeURIComponent(actionKey)}/complete`,
      { channel: input?.channel ?? null },
    );
  },
};
